import React from "react";
import AddRepairingOrder from "./AddRepairingOrder";
import { useButtonTableStyle } from "../utils/useButtonTableStyle";
import { resolveRepairingOrderIsQuote } from "../utils/customerLedgerDocTypes";
import "../assets/css/theme-table-header.css";

/** View-only repairing order — same UI as edit, loads show API. */
export default function ViewRepairingOrder({
  repairingOrderId,
  onClose,
  masterGoldRate,
  masterSilverRate,
  isQuote,
  docNumber,
}) {
  const { cardClass } = useButtonTableStyle();
  const resolvedIsQuote =
    isQuote !== undefined && isQuote !== null
      ? Boolean(isQuote)
      : resolveRepairingOrderIsQuote(docNumber);

  return (
    <div className={cardClass}>
      <AddRepairingOrder
        repairingOrderId={repairingOrderId}
        onClose={onClose}
        masterGoldRate={masterGoldRate}
        masterSilverRate={masterSilverRate}
        pageTitle="View Repair Order"
        isQuote={resolvedIsQuote}
        viewOnly
      />
    </div>
  );
}
